import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

const AlertDialog = (props) => {
  const { show, handleClose, title, message } = props;

  return (
    <Modal show={show} onHide={handleClose} size="sm">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ fontSize: 14 }}>{message}</Modal.Body>
      <Modal.Footer className="p-2">
        {props.children.length ? (
          <div className="d-flex justify-content-between w-100">
            {props.children}
          </div>
        ) : (
          props.children
        )}
      </Modal.Footer>
    </Modal>
  );
};

AlertDialog.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  handleClose: PropTypes.func,
};

export default AlertDialog;
